export const Marketplace = ({ close }: { close: Function }) => {
  return <div>Marketplace</div>;
};
